import React from "react";

import {Box, Chip, Container, Divider, Link, Paper, Stack, Typography} from "@mui/material";
// @ts-ignore
import vldLogo from "@logo/vld-2026.png";
// @ts-ignore
import blr07 from "../../assets/images/articles/2025-10-31/blr-07.png";
// @ts-ignore
import blr10 from "../../assets/images/articles/2025-10-31/blr-10.png";
// @ts-ignore
import reg1 from "../../assets/images/articles/2025-10-31/reg-1.png";
// @ts-ignore
import reg2 from "../../assets/images/articles/2025-10-31/reg-2.png";
// Title
import SectionTitle from "../../components/layouts/others/title-section.layout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faVoteYea,
    faHome,
    faInfoCircle,
    faExclamationTriangle,
    faCheckCircle,
    faTimesCircle,
    faMapMarkedAlt,
    faBuilding,
    faFileAlt,
    faArrowRight,
    faBullhorn,
    faShieldAlt
} from "@fortawesome/free-solid-svg-icons";

const ARTICLE20251031: React.FC = () => {

    return(
        <>
            <Container maxWidth="lg" sx={{ mb: 6 }}>
                <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
                <Stack spacing={3}>
                    <Box textAlign="center">
                        <img
                            src={vldLogo}
                            alt="Association Vivre la démocratie à BLR"
                            style={{ width: 300, marginBottom: 10, marginTop: 10 }}
                        />
                        <Typography
                            variant="h5"
                            color="primary"
                            fontWeight={700}
                            gutterBottom
                            sx={{ pt: 1, pb: 1 }}
                        >
                            PLUi voté : quels impacts concernant votre propriété ?
                        </Typography>
                    </Box>
                    <Divider />

                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mb={1}>
                        <FontAwesomeIcon icon={faVoteYea} color="#0288d1" />
                        <Typography variant="subtitle1" fontWeight={700} color="primary">
                            La CAPF a publié le PLUi adopté le 16 octobre dernier.
                        </Typography>
                    </Stack>

                    <Typography align="center" color="text.secondary">
                        Dans la philosophie de VLD, nous souhaitons apporter une information fiable et objective afin d'enrichir le débat public.
                    </Typography>

                    {/* Section rappel SMS */}
                    <Paper elevation={3} sx={{ mt: 3, p: 3, background: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)" }}>
                        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center" mb={2}>
                            <FontAwesomeIcon icon={faInfoCircle} color="#2e7d32" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#2e7d32">
                                Rappel concernant les Secteurs de Mixité Sociale (SMS)
                            </Typography>
                        </Stack>

                        <Typography paragraph color="text.secondary" mb={3}>
                            Il faut bien distinguer deux types de SMS :
                        </Typography>

                        <Stack spacing={2}>
                            <Paper elevation={2} sx={{ p: 2.5, bgcolor: "white", borderLeft: "5px solid #1976d2" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box sx={{ mt: 0.5 }}>
                                        <FontAwesomeIcon icon={faBuilding} color="#1976d2" size="lg" />
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={700} color="#1976d2" gutterBottom>
                                            Les SMS de type 1
                                        </Typography>
                                        <Typography color="text.secondary">
                                            Imposent <b>80% de logements sociaux</b> à partir de la réalisation de <b>3 logements</b> (pourcentage abaissé à 75% à partir de 16 logements construits) sur l'ensemble des <b>zones U</b> de la commune.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Paper>

                            <Paper elevation={2} sx={{ p: 2.5, bgcolor: "white", borderLeft: "5px solid #d32f2f" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box sx={{ mt: 0.5 }}>
                                        <FontAwesomeIcon icon={faHome} color="#d32f2f" size="lg" />
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={700} color="#d32f2f" gutterBottom>
                                            Les SMS de type 2
                                        </Typography>
                                        <Typography color="text.secondary">
                                            Imposent <b>80% de logements</b> à partir du <b>premier logement réalisé</b>, sur certaines parcelles identifiées au règlement graphique.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Paper>
                        </Stack>
                    </Paper>

                    {/* Principales évolutions */}
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mt={3} mb={2}>
                        <FontAwesomeIcon icon={faMapMarkedAlt} color="#f57c00" />
                        <Typography variant="h6" fontWeight={700} color="#f57c00">
                            Principales évolutions par rapport au PLUi arrêté en juin 2024 concernant les SMS
                        </Typography>
                    </Stack>

                    {/* Ce qui ne change pas */}
                    <Box sx={{ bgcolor: "#e8f5e9", borderRadius: 2, p: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <FontAwesomeIcon icon={faCheckCircle} color="#43a047" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#2e7d32">
                                Ce qui ne change pas :
                            </Typography>
                        </Stack>

                        <Stack component="ul" spacing={1.5} sx={{ pl: 3 }}>
                            <Typography component="li" color="text.secondary">
                                Les obligations liées aux SMS : le PLUi arrêté en juin 2024 mentionnait déjà les deux règles.
                            </Typography>
                            <Typography component="li" color="text.secondary">
                                Toutes les zones U identifiées en tant que SMS de type 1.
                            </Typography>
                            <Typography component="li" color="text.secondary">
                                22 parcelles identifiées en tant que SMS de type 2.
                            </Typography>
                        </Stack>
                    </Box>

                    {/* Ce qui change */}
                    <Box sx={{ bgcolor: "#fff3e0", borderRadius: 2, p: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <FontAwesomeIcon icon={faExclamationTriangle} color="#f57c00" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#e65100">
                                Ce qui change :
                            </Typography>
                        </Stack>

                        <Stack spacing={2}>
                            <Typography color="text.secondary">
                                <b>Création de typologies de SMS</b> afin de distinguer les deux types d'obligations (voir supra), intégrées au règlement graphique et écrit.
                            </Typography>

                            <Typography color="text.secondary">
                                <b>Identification graphique</b> de l'ensemble des secteurs des zones U concernés par les SMS de type 1, visible sur la "petite carte" en bas à droite du document.
                            </Typography>

                            <Box sx={{ bgcolor: "#ffe0b2", borderRadius: 1, p: 2, mt: 1 }}>
                                <Typography fontWeight={700} color="#e65100" gutterBottom>
                                    SMS de type 2 :
                                </Typography>
                                <Typography color="text.secondary" mb={1}>
                                    <b>24 SMS</b> dans la dernière version contre <b>22 en 2024</b>, avec 4 modifications :
                                </Typography>

                                <Stack direction="row" alignItems="center" spacing={1} mt={1.5} mb={1}>
                                    <FontAwesomeIcon icon={faCheckCircle} color="#43a047" />
                                    <Typography color="text.secondary" fontWeight={600}>
                                        3 parcelles SMS en plus :
                                    </Typography>
                                </Stack>
                                <Typography color="text.secondary" sx={{ pl: 4 }}>
                                    rue Demeufve / rue de la Messe / quai de la Ruelle
                                </Typography>

                                <Stack direction="row" alignItems="center" spacing={1} mt={1.5} mb={1}>
                                    <FontAwesomeIcon icon={faTimesCircle} color="#d32f2f" />
                                    <Typography color="text.secondary" fontWeight={600}>
                                        1 parcelle SMS en moins :
                                    </Typography>
                                </Stack>
                                <Typography color="text.secondary" sx={{ pl: 4 }}>
                                    rue Pasteur
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>

                    {/* OAP */}
                    <Box sx={{ bgcolor: "#e3f2fd", borderRadius: 2, p: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <FontAwesomeIcon icon={faFileAlt} color="#1976d2" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#0d47a1">
                                Principales évolutions concernant les OAP :
                            </Typography>
                        </Stack>

                        <Stack direction="row" spacing={2} alignItems="center">
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <FontAwesomeIcon icon={faTimesCircle} color="#d32f2f" />
                                <Typography color="text.secondary">
                                    Suppression de l'OAP de la <b>rue des Sesçois</b>
                                </Typography>
                            </Stack>
                            <FontAwesomeIcon icon={faArrowRight} color="#757575" />
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <FontAwesomeIcon icon={faCheckCircle} color="#43a047" />
                                <Typography color="text.secondary">
                                    Ajout de l'OAP de la <b>Place de la République</b>
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>

                    {/* Avant / Après - Règlement écrit */}
                    <Divider sx={{ mt: 4, mb: 2 }} />

                    <Typography variant="h6" fontWeight={700} color="primary" align="center" gutterBottom>
                        Avant / après :
                    </Typography>

                    <Paper elevation={2} sx={{ p: 3, bgcolor: "#fafafa" }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <FontAwesomeIcon icon={faFileAlt} color="#5e35b1" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#5e35b1">
                                Règlement écrit :
                            </Typography>
                        </Stack>
                        {/* Images règlement écrit avant/après */}
                        <Stack
                            direction={{ xs: "column", md: "row" }}
                            spacing={2}
                            sx={{ mb: 2 }}
                            alignItems="stretch"
                        >
                            <Box sx={{ flex: 1, textAlign: "center", display: "flex", flexDirection: "column" }}>
                                <Typography
                                    variant="subtitle2"
                                    fontWeight={700}
                                    color="#5e35b1"
                                    gutterBottom
                                >
                                    Avant (juin 2024)
                                </Typography>
                                <Box
                                    component="img"
                                    src={reg1}
                                    alt="Règlement écrit PLUi juin 2024"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        borderRadius: 1,
                                        border: "2px solid #5e35b1",
                                        boxShadow: "0 2px 8px rgba(94, 53, 177, 0.2)"
                                    }}
                                />
                            </Box>
                            <Box sx={{ flex: 1, textAlign: "center", display: "flex", flexDirection: "column" }}>
                                <Typography
                                    variant="subtitle2"
                                    fontWeight={700}
                                    color="#d32f2f"
                                    gutterBottom
                                >
                                    Après (octobre 2025)
                                </Typography>
                                <Box
                                    component="img"
                                    src={reg2}
                                    alt="Règlement écrit PLUi octobre 2025"
                                    sx={{
                                        background: 'white',
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        borderRadius: 1,
                                        border: "2px solid #d32f2f",
                                        boxShadow: "0 2px 8px rgba(211, 47, 47, 0.2)"
                                    }}
                                />
                            </Box>
                        </Stack>
                        <Typography fontWeight={700} color="text.primary" mt={3} mb={1}>
                            Sources :
                        </Typography>
                        <Stack component="ul" spacing={1} sx={{ pl: 3 }}>
                            <Typography component="li" color="text.secondary">
                                PLUi arrêté le 27 juin 2024 :{" "}
                                <Link
                                    href="https://www.pays-fontainebleau.fr/wp-content/uploads/2024/07/3a-Reglement-ecrit.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ fontWeight: 600 }}
                                >
                                    3a-Reglement-ecrit.pdf (p. 18)
                                </Link>
                            </Typography>
                            <Typography component="li" color="text.secondary">
                                PLUi voté le 16 octobre 2025 :{" "}
                                <Link
                                    href="https://www.pays-fontainebleau.fr/wp-content/uploads/2025/10/3_REGLEMENT-ECRIT.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ fontWeight: 600 }}
                                >
                                    3_REGLEMENT-ECRIT.pdf (p. 28 et 29)
                                </Link>
                            </Typography>
                        </Stack>
                    </Paper>

                    {/* Règlement graphique */}
                    <Paper elevation={2} sx={{ p: 3, bgcolor: "#fafafa", mt: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <FontAwesomeIcon icon={faMapMarkedAlt} color="#00897b" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#00897b">
                                Règlement graphique :
                            </Typography>
                        </Stack>
                        {/* Images règlement graphique avant/après */}
                        <Stack
                            direction={{ xs: "column", md: "row" }}
                            spacing={2}
                            sx={{ mb: 2 }}
                        >
                            <Box sx={{ flex: 1, textAlign: "center" }}>
                                <Typography
                                    variant="subtitle2"
                                    fontWeight={700}
                                    color="#00897b"
                                    gutterBottom
                                >
                                    Avant (juin 2024)
                                </Typography>
                                <Box
                                    component="img"
                                    src={blr07}
                                    alt="Règlement graphique PLUi juin 2024"
                                    sx={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: 1,
                                        border: "2px solid #00897b",
                                        boxShadow: "0 2px 8px rgba(0, 137, 123, 0.2)"
                                    }}
                                />
                            </Box>
                            <Box sx={{ flex: 1, textAlign: "center" }}>
                                <Typography
                                    variant="subtitle2"
                                    fontWeight={700}
                                    color="#d32f2f"
                                    gutterBottom
                                >
                                    Après (octobre 2025)
                                </Typography>
                                <Box
                                    component="img"
                                    src={blr10}
                                    alt="Règlement graphique PLUi octobre 2025"
                                    sx={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: 1,
                                        border: "2px solid #d32f2f",
                                        boxShadow: "0 2px 8px rgba(211, 47, 47, 0.2)"
                                    }}
                                />
                            </Box>
                        </Stack>

                        <Typography fontWeight={700} color="text.primary" mt={3} mb={1}>
                            Sources :
                        </Typography>
                        <Stack component="ul" spacing={1} sx={{ pl: 3 }}>
                            <Typography component="li" color="text.secondary">
                                PLUi arrêté le 27 juin 2024 :{" "}
                                <Link
                                    href="https://www.pays-fontainebleau.fr/wp-content/uploads/2024/07/Bois-le-Roi.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ fontWeight: 600 }}
                                >
                                    Bois-le-Roi.pdf
                                </Link>
                            </Typography>
                            <Typography component="li" color="text.secondary">
                                PLUi voté le 16 octobre 2025 :{" "}
                                <Link
                                    href="https://www.pays-fontainebleau.fr/wp-content/uploads/2025/10/Bois-le-Roi.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ fontWeight: 600 }}
                                >
                                    Bois-le-Roi.pdf
                                </Link>
                            </Typography>
                        </Stack>
                    </Paper>

                    {/* À quels types d'opérations */}
                    <Box sx={{ bgcolor: "#f3e5f5", borderRadius: 2, p: 3, mt: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <FontAwesomeIcon icon={faInfoCircle} color="#7b1fa2" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#7b1fa2">
                                À quels types d'opérations ces règles s'appliquent-elles ?
                            </Typography>
                        </Stack>

                        <Typography color="text.secondary">
                            En cas de réalisation d'un <b>programme de logements</b>. Cela comprend les constructions nouvelles, ainsi que les constructions existantes (extension de construction, division de bâtiment, changement de destination au profit de l'habitat).
                        </Typography>
                    </Box>

                    {/* Conclusion */}
                    <Paper elevation={3} sx={{ mt: 4, p: 3, background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)" }}>
                        <Stack spacing={3}>
                            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                                <FontAwesomeIcon icon={faBullhorn} color="#c62828" size="lg" />
                                <Typography fontWeight={700} variant="h6" color="#c62828">
                                    Notre conclusion :
                                </Typography>
                            </Stack>

                            <Paper elevation={1} sx={{ p: 3, bgcolor: "white", borderLeft: "5px solid #d32f2f" }}>
                                <Typography paragraph color="text.secondary">
                                    Le Maire et sa majorité sont restés sourds aux arguments et à l'opposition des Bacots : <b>aucune évolution des règles liées aux SMS.</b>
                                </Typography>

                                <Divider sx={{ my: 2 }} />

                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box sx={{ mt: 0.5 }}>
                                        <FontAwesomeIcon icon={faShieldAlt} color="#d32f2f" size="lg" />
                                    </Box>
                                    <Box>
                                        <Typography paragraph color="text.secondary">
                                            La position de <b>VLD 2026</b> demeure inchangée : les SMS de type 2, tels que définis par le Maire et sa majorité et intégrés au PLUi, constituent une <b>atteinte inacceptable au droit de propriété</b>.
                                        </Typography>
                                        <Typography fontWeight={700} color="#c62828" fontSize="1.1rem">
                                            Nous mettrons tout en œuvre pour les supprimer.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Paper>

                            <Chip
                                icon={<FontAwesomeIcon icon={faVoteYea} />}
                                label="VLD 2026 : Pour une démocratie locale"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "1.1rem",
                                    background: "white",
                                    color: "#c62828",
                                    py: 2.5,
                                    px: 2,
                                    borderRadius: "20px",
                                    boxShadow: "0 2px 8px rgba(198, 40, 40, 0.2)",
                                    alignSelf: "center"
                                }}
                            />
                        </Stack>
                    </Paper>

                    <Typography align="center" variant="subtitle2" sx={{ fontStyle: "italic", mt: 3, fontWeight: 600 }}>
                        Votre équipe VLD2026
                    </Typography>
                </Stack>
            </Container>
        </>
    )
}

export default ARTICLE20251031;